import { render, staticRenderFns } from "./StocMateriale.vue?vue&type=template&id=2fa02340&scoped=true"
import script from "./StocMateriale.vue?vue&type=script&lang=js"
export * from "./StocMateriale.vue?vue&type=script&lang=js"
import style0 from "./StocMateriale.vue?vue&type=style&index=0&id=2fa02340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa02340",
  null
  
)

export default component.exports